// @flow

export * from './types';

export {
  getDocumentTypeFromFormattedValue,
  getDocumentTypeFromRawValue,
  getDocumentTypeInferredFromValue,
} from './get-document-type';
